var _style, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPowerbi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 652 652",
    style: {
      enableBackground: "new 0 0 652 652"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.4,336.2v30.2H207v-79.9h22c8.5,0,15.2,2.1,19.9,6.2c4.7,4.2,7,10,7,17.6s-2.6,13.8-7.8,18.6s-12.3,7.2-21.1,7.2H216.4z  M216.4,295v32.8h9.8c6.5,0,11.4-1.5,14.8-4.4s5.1-7.1,5.1-12.5c0-10.5-6.2-15.8-18.7-15.8H216.4z M289.3,367.8 c-8.4,0-15.2-2.7-20.2-8c-5-5.3-7.5-12.4-7.5-21.2c0-9.6,2.6-17.1,7.9-22.5c5.2-5.4,12.3-8.1,21.2-8.1c8.5,0,15.1,2.6,19.9,7.9 c4.8,5.2,7.2,12.5,7.2,21.8c0,9.1-2.6,16.4-7.7,21.9S298,367.8,289.3,367.8z M290,315.7c-5.9,0-10.5,2-13.9,6 c-3.4,4-5.1,9.5-5.1,16.5c0,6.8,1.7,12.1,5.2,16c3.5,3.9,8.1,5.9,13.9,5.9c5.9,0,10.4-1.9,13.6-5.7s4.8-9.3,4.8-16.3 c0-7.1-1.6-12.6-4.8-16.5C300.5,317.7,295.9,315.7,290,315.7z M404.2,309.4l-17.1,57.1h-9.5l-11.8-40.8c-0.4-1.6-0.7-3.3-0.9-5.3 h-0.2c-0.1,1.3-0.5,3.1-1.2,5.2l-12.8,41h-9.1l-17.3-57.1h9.6l11.8,42.9c0.4,1.3,0.6,3,0.8,5.1h0.4c0.1-1.6,0.4-3.4,1-5.2l13.1-42.8 h8.4l11.8,43c0.4,1.4,0.7,3.1,0.8,5.1h0.4c0.1-1.4,0.4-3.2,0.9-5.1l11.6-43H404.2z M460.7,340.2h-40.3c0.1,6.4,1.9,11.3,5.1,14.7 s7.8,5.2,13.5,5.2c6.4,0,12.3-2.1,17.7-6.4v8.6c-5,3.6-11.6,5.5-19.9,5.5c-8.1,0-14.4-2.6-19-7.8c-4.6-5.2-6.9-12.5-6.9-21.9 c0-8.9,2.5-16.1,7.5-21.7c5-5.6,11.3-8.4,18.7-8.4c7.5,0,13.2,2.4,17.3,7.2c4.1,4.8,6.1,11.5,6.1,20.1V340.2z M451.3,332.4 c0-5.3-1.3-9.4-3.8-12.3c-2.5-2.9-6-4.4-10.4-4.4c-4.3,0-8,1.5-11,4.6c-3,3.1-4.9,7.1-5.6,12.1H451.3z M504.2,318.6 c-1.6-1.2-3.9-1.8-6.9-1.8c-3.9,0-7.2,1.8-9.8,5.5c-2.6,3.7-3.9,8.7-3.9,15v29.1h-9.1v-57.1h9.1v11.8h0.2c1.3-4,3.3-7.1,6-9.4 c2.7-2.2,5.7-3.4,9-3.4c2.4,0,4.2,0.3,5.5,0.8V318.6z M546.7,366.4v-79.9h22.7c6.9,0,12.4,1.7,16.4,5.1c4,3.4,6.1,7.8,6.1,13.2 c0,4.5-1.2,8.5-3.7,11.8c-2.5,3.3-5.8,5.7-10.1,7.1v0.2c5.4,0.6,9.7,2.7,12.9,6.1c3.2,3.4,4.8,7.9,4.8,13.4c0,6.8-2.5,12.4-7.4,16.6 c-4.9,4.2-11.1,6.4-18.6,6.4H546.7z M556,295v25.8h9.6c5.1,0,9.2-1.2,12.1-3.7c2.9-2.5,4.4-6,4.4-10.4c0-7.8-5.1-11.6-15.3-11.6H556 z M556,329.2V358h12.7c5.5,0,9.8-1.3,12.8-3.9c3-2.6,4.5-6.2,4.5-10.7c0-9.4-6.4-14.2-19.3-14.2H556z M621.4,366.4h-9.4v-79.9h9.4 V366.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.1811,
    y1: 412.2651,
    x2: 148.1974,
    y2: 259.2164,
    gradientTransform: "matrix(1 0 0 -1 0 652)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6AD10"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C87E0E"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.3,246.5v148.9c0,3.7-3,6.8-6.8,6.8H94.2c-3.7,0-6.8-3-6.8-6.8V246.5c0-3.7,3-6.8,6.8-6.8h42.3 C140.2,239.8,143.3,242.8,143.3,246.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.3633,
    y1: 370.0888,
    x2: 110.3461,
    y2: 252.1231,
    gradientTransform: "matrix(1 0 0 -1 0 652)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6D751"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6AD10"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.3,287.2v115.1H54.4V287.2c0-3.7,3-6.8,6.8-6.8h42.3C107.2,280.4,110.3,283.4,110.3,287.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.1099,
    y1: 334.9642,
    x2: 63.588,
    y2: 255.5859,
    gradientTransform: "matrix(1 0 0 -1 0 652)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9E589"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6D751"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21.4,327.8v67.7c0,3.7,3,6.8,6.8,6.8h49.1v-74.5c0-3.7-3-6.8-6.8-6.8H28.2C24.5,321,21.4,324,21.4,327.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerbi);
export default __webpack_public_path__ + "static/media/powerbi.9c1be457ba8ce586fbb8090481bfa446.svg";
export { ForwardRef as ReactComponent };